import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ScorecardDescription } from '@fgb/core';

@Component({
  selector: 'fgbcl-scorecard-description-body',
  templateUrl: './scorecard-description-body.component.html',
  styleUrl: './scorecard-description-body.component.scss',
})
export class ScorecardDescriptionBodyComponent implements OnChanges {
  @Input() scorecardDescription: ScorecardDescription;
  @Output() onNextClick: EventEmitter<any> = new EventEmitter();
  @Output() onPrevious: EventEmitter<any> = new EventEmitter();
  @Input() isSponsorInBody: boolean = false;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {}

  nextClick() {
    this.onNextClick.emit(true);
  }

  previousClick() {
    this.onPrevious.emit(true);
  }

  get hasSponsor(): boolean {
    return this.scorecardDescription?.currentScorecard?.Sponsor?.SponsorImage;
  }
}
